// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"36":"dc7d5310","884":"7b01a787","956":"5212e116"}[chunkId] + ".chunk.css";
};